import { Box } from '@chakra-ui/react';
import { VintraceSingleMono } from '@carafe/components';

export const FormLogo = (): JSX.Element => (
  <Box pt={3} pb={2}>
    <VintraceSingleMono scale={1.5} fill="#319795" />
  </Box>
);
